var _defs, _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoto51BlueDesktopIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "13 11 241.58 241.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #58c0cf;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3, .cls-4, .cls-5 {\n        fill: #ebf1f3;\n      }\n\n      .cls-4 {\n        opacity: .6;\n      }\n\n      .cls-5 {\n        opacity: .85;\n      }\n\n      .cls-6 {\n        opacity: .3;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M160.97,93.47c-6.79,0-12.3,2.92-12.3,6.53s5.51,6.53,12.3,6.53c1.32,0,2.56-.14,3.75-.34,3.88-.66,6.9-2.31,8.02-4.4.31-.57.52-1.16.52-1.79,0-3.61-5.5-6.53-12.3-6.53Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M172.48,165.11c-1.29-1.89-4.16-3.35-7.77-3.96-1.19-.2-2.43-.34-3.75-.34-6.79,0-12.3,2.92-12.3,6.53s5.51,6.53,12.3,6.53,12.3-2.92,12.3-6.53c0-.79-.3-1.53-.78-2.23Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 134.09,
    cy: 131.7,
    r: 120.53
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M134.09,244.35c-62.12,0-112.65-50.54-112.65-112.65S71.98,19.05,134.09,19.05s112.65,50.54,112.65,112.65-50.54,112.65-112.65,112.65ZM134.09,23.65c-59.58,0-108.05,48.47-108.05,108.05s48.47,108.05,108.05,108.05,108.05-48.47,108.05-108.05S193.67,23.65,134.09,23.65Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M117.41,109.18c1.27,0,2.3-1.03,2.3-2.3s-1.03-2.3-2.3-2.3h-13.36c-1.27,0-2.3,1.03-2.3,2.3v14.7l-10.69,8.09c-.57.43-.91,1.11-.91,1.83s.34,1.4.91,1.83l10.69,8.09v14.7c0,1.27,1.03,2.3,2.3,2.3h13.36c1.27,0,2.3-1.03,2.3-2.3s-1.03-2.3-2.3-2.3h-11.06v-44.66h11.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M177.13,129.68l-10.69-8.09v-14.71c0-1.27-1.03-2.3-2.3-2.3h-13.36c-1.27,0-2.3,1.03-2.3,2.3s1.03,2.3,2.3,2.3h11.06v44.66h-11.06c-1.27,0-2.3,1.03-2.3,2.3s1.03,2.3,2.3,2.3h13.36c1.27,0,2.3-1.03,2.3-2.3v-14.71l10.69-8.09c.57-.43.91-1.11.91-1.83s-.34-1.4-.91-1.83Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 134.09,
    cy: 131.51,
    r: 14.84
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 193.81,
    cy: 73.23,
    rx: 17.98,
    ry: 9.55
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 74.38,
    cy: 73.23,
    rx: 17.98,
    ry: 9.55
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 193.81,
    cy: 190.17,
    rx: 17.98,
    ry: 9.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M175.74,90.93c-6.89,0-12.47,2.97-12.47,6.63,0,.63.22,1.23.53,1.81,1.14,2.12,4.2,3.79,8.14,4.47,1.2.21,2.47.35,3.8.35,6.89,0,12.47-2.97,12.47-6.63s-5.58-6.63-12.47-6.63Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 74.38,
    cy: 190.17,
    rx: 17.98,
    ry: 9.55
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M92.44,90.93c-6.89,0-12.47,2.97-12.47,6.63s5.58,6.63,12.47,6.63c1.33,0,2.6-.14,3.8-.35,3.94-.67,7-2.34,8.14-4.47.31-.58.53-1.18.53-1.81,0-3.66-5.58-6.63-12.47-6.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M175.74,159.23c-1.33,0-2.6.14-3.8.35-3.66.63-6.57,2.11-7.88,4.02-.49.71-.79,1.46-.79,2.26,0,3.66,5.58,6.63,12.47,6.63s12.47-2.97,12.47-6.63-5.58-6.63-12.47-6.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M104.12,163.59c-1.31-1.91-4.22-3.39-7.88-4.02-1.21-.21-2.47-.35-3.8-.35-6.89,0-12.47,2.97-12.47,6.63s5.58,6.63,12.47,6.63,12.47-2.97,12.47-6.63c0-.8-.31-1.55-.79-2.26Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto51BlueDesktopIcon);
export default __webpack_public_path__ + "static/media/photo51-blue-desktop-icon.4a15f678f5a927bf14121b05ab9709e6.svg";
export { ForwardRef as ReactComponent };